export default {
  overview: {
    title: "Dateien",
    // Benennt die Entitätsarten nicht einzeln auf: die Ordnerliste zeigt ohnehin nur die Bereiche,
    // die der angemeldeten Rolle offenstehen.
    subtitle: "Alle abgelegten Dateien an einer Stelle.",
    // Sucht Ordner und Dateien zugleich: Ordner über den Namen des Datensatzes, Dateien über
    // Dateiname und Tag. Deshalb "Ordner oder Datei" und nicht nur "Datei".
    search: {
      placeholder: "Ordner oder Datei suchen",
      results: "Suchergebnisse",
      // Zählt Ordner und Dateien zusammen. Die Suche ist gedeckelt statt seitenweise, deshalb ist
      // die Zahl auch die Gesamtzahl.
      count: "{count} Treffer",
    },
    // Der einzige Filter dieses Bildschirms — und bewusst kein zweites Suchfeld: gesucht wird nach
    // einem Namen, den man kennt, gefiltert wird nach einem Zustand, für den es keinen Namen gibt.
    // Er gilt für Ordner wie Dateien, bleibt beim Hineingehen erhalten und steht in der URL.
    //
    // Drei Zustände, die einander ausschließen — keine Liste sich überschneidender Fragen.
    // „Abgelaufen“ und „Läuft bald ab“ ist eine Datei entweder/oder, also stehen beide einzeln da.
    // Einen zusammengefassten Eintrag gab es hier einmal, mit „Nur abgelaufen“ darunter: zwei
    // Einträge, die wie Alternativen aussahen, während der eine den anderen enthielt.
    due_filter: {
      // Steht am geschlossenen Feld, solange nicht gefiltert wird: ein bloßes „Alle“ neben der Suche
      // sagt nicht, wovon alle. Ist gefiltert, trägt der Wert sich selbst.
      label: "Gültig bis",
      options: {
        // Kein vierter Zustand, sondern der Ruhezustand des Filters.
        all: "Alle",
        expired: "Abgelaufen",
        expiring: "Läuft bald ab",
        // Hat ein Ablaufdatum und ist noch deutlich davor. Zusammen mit den beiden anderen ergibt
        // das „alles mit Ablaufdatum“ — Dateien ohne Datum laufen nicht ab und sind in keinem der
        // drei Zustände.
        valid: "Gültig",
      },
    },
    path: {
      label: "Pfad",
      // Die Wurzel der Ablage. Trägt denselben Namen wie der Menüpunkt, weil sie dasselbe ist.
      root: "Dateien",
    },
    // Der Speicherplatz des gesamten Arbeitsbereichs, rechts in der Werkzeugleiste — das Einzige,
    // was die Werkzeugleiste über den Arbeitsbereich als Ganzes sagt.
    //
    // Daneben stand einmal eine laufende Gesamtsumme ("12.312 Dateien · 3,4 GiB"). Die Größe war
    // dieselbe Zahl wie hier, die Anzahl beantwortete eine Frage, für die niemand eine Dateiablage
    // öffnet. Was ein Ordner enthält, steht am Ordner, im Pfadbalken.
    storage: {
      // Nur die beiden Größen: wie voll es ist, zeigt der Balken darunter, und "belegt" oder eine
      // Prozentzahl daneben sagt dasselbe ein zweites Mal — auf einer Zeile, die neben dem Suchfeld
      // steht und deshalb kurz bleiben muss.
      used: "{used} von {max}",
      // Für Arbeitsbereiche ohne hinterlegtes Limit — dort gibt es keinen Anteil, den ein Balken
      // zeigen könnte, also nur die belegte Größe, und die braucht ihr Wort.
      used_uncapped: "{used} belegt",
      // Beide nur im Tooltip: der Rest ist die Zahl, an der der nächste Upload gemessen wird
      // ("passen die 400 MB noch?"), aber er muss nicht dauerhaft in der Werkzeugleiste stehen.
      free: "{size} frei",
      // Kein "0 B frei": voll ist ein Zustand und keine Restgröße.
      full: "Kein Speicherplatz mehr frei",
    },
    // Zweite Zeile im Pfadbalken: was der geöffnete Ordner insgesamt enthält.
    folder_summary: "{files} Dateien · {size}",
    // Zweite Zeile einer Ordnerzeile. Zählt alles darunter, auch in den Berichtsordnern.
    folder_files: "{count} Dateien",
    // Verweist vom Ordner auf den Datensatz, an dem die Dateien hängen.
    open_owner: "Datensatz öffnen",
    // Hochladen geht nur dort, wo die Dateien auch liegen: in einem Datensatz-Ordner. Ein Bereich
    // enthält Datensätze und keine Dateien, und ein Berichtsordner umfasst viele Berichte — dort
    // wäre nicht zu entscheiden, an welchem die Datei hängen soll.
    // Öffnet direkt den Dateidialog des Betriebssystems. Es gibt nichts zu bestätigen und nichts
    // einzustellen, also auch keinen Zwischenschritt.
    upload: {
      action: "Hochladen",
      // Erscheint über der Dateiliste, solange Dateien darüber gezogen werden.
      drop: "In „{folder}“ ablegen",
      // Gleiche Stelle, wenn der geöffnete Ordner keine Dateien aufnehmen kann — ein Bereich, ein
      // Berichtsordner, die Suche. Sagt, warum nichts passiert, statt einfach nichts zu tun.
      drop_blocked: "Hier können keine Dateien abgelegt werden",
    },
    // Zeilenmenü — erreichbar über die drei Punkte und über einen Rechtsklick auf die Zeile.
    menu: {
      // Nur für Screenreader: die drei Punkte allein sagen nicht, wozu sie gehören.
      label: "Weitere Aktionen",
      // Öffnet die Datei selbst. Deaktiviert bei Formaten, die sich nicht anzeigen lassen
      // (Tabellen, Archive) — dort führt der Klick auf den Namen direkt in die Details.
      preview: "Vorschau",
      // Dieselbe Ansicht, zwei Beschriftungen: ohne Schreibrecht lassen sich die Tags nur lesen.
      edit: "Bearbeiten",
      details: "Details anzeigen",
      // Nur bei Ordnern.
      open: "Öffnen",
    },
    table: {
      headers: {
        name: "Name",
        // Nur in der Suche: dort können die Zeilen aus jedem Ordner stammen.
        location: "Ordner",
        size: "Größe",
        // Bewusst nicht "Geändert": die Spalte zeigt das Datum des Uploads, und bei einem Ordner
        // den jüngsten Upload darin. Ein späteres Umtaggen ändert sie nicht.
        uploaded: "Hochgeladen",
        // Sortiert nach dem nächstliegenden Datum; Dateien ohne Ablaufdatum stehen in beiden
        // Richtungen hinten.
        due: "Gültig bis",
        tags: "Tags",
      },
      // Überschriften über den beiden Blöcken. Erscheinen nur, wenn beides zugleich in der Liste
      // steht — also im Projekt (Berichtsordner plus eigene Dateien) und in der Suche.
      groups: {
        folders: "Ordner",
        files: "Dateien",
      },
      // Ergänzt die Spaltenüberschrift für Screenreader: der Pfeil allein sagt nicht, was ein Klick tut.
      sort: {
        ascending: "aufsteigend sortieren",
        descending: "absteigend sortieren",
      },
    },
    empty: {
      // Gar nichts vorhanden: entweder gibt es keine Dateien, oder die Rolle darf keine davon sehen.
      root: "Keine Dateien vorhanden.",
      folder: "In diesem Ordner liegen keine Dateien.",
      search: "Nichts gefunden.",
      // Hat Vorrang vor den drei anderen: „In diesem Ordner liegen keine Dateien“ wäre gefiltert
      // schlicht falsch und läse sich wie ein leerer Ordner statt wie ein Filter ohne Treffer.
      filtered: "Keine Dateien mit diesem Ablaufstatus.",
    },
  },
  // Nur für die zwei Berichtsarten: sie haben keinen eigenen Navigationseintrag, dessen Beschriftung
  // wie bei den übrigen Typen wiederverwendet werden könnte.
  types: {
    constructionreport: "[[cr.pl]]",
    hourlywagereport: "[[hwr.pl]]",
    // Nicht vom Dateibrowser genutzt: das Protokoll-Tab benennt damit Verweise auf Datensatzarten,
    // die keine eigene Seite haben.
    hourlywageinvoice: "[[hwi.pl]]",
    contactposition: "Ansprechpartner-Rollen",
  },
}
